export default "__VITE_ASSET__fe4c88f7__"